import { Grid } from "@material-ui/core";
import * as React from "react";
import { Datagrid, FunctionField, List } from "react-admin";
import { CustomDateField } from "../../../../../Components/CustomDateField";
import CreatedByField from "../../../../../Components/ReferenceFields/CreatedBy/CreatedByField";
import { ExcelExport } from "../../../../../Helper/ExportExcel";
import { SourceVwUser } from "../../../../../Constants/Source";
import { UpdateHistoryExcelColumns, UpdateHistoryExcelName } from "../Constant/Excel";
import { AarStorageLocations } from "../../../../../Enums/AarStorageLocations";
import { AarConditions } from "../../../../../Enums/AarConditions";
import RefNumberField from "./AarStorageRefNumberField";

const AarStorageUpdateHistory = props => {
  const getFormattedStorageChange = (record: any) => {
    const prevRecord = JSON.parse(record.oldValues);
    const currentRecord = JSON.parse(record.newValues);
    const prev = AarStorageLocations?.find(x => x.Value === prevRecord?.Storage)?.Description || "";
    const current = AarStorageLocations?.find(x => x.Value === currentRecord?.Storage)?.Description || "";
    return prevRecord?.Storage === currentRecord?.Storage ? "Not Changed" : `${prev} ---> ${current}`;
  };
  const getFormattedConditionsChange = (record: any) => {
    const prevRecord = JSON.parse(record.oldValues);
    const currentRecord = JSON.parse(record.newValues);
    const prev = AarConditions?.find(x => x.Value === prevRecord?.Condition)?.Description || "";
    const current = AarConditions?.find(x => x.Value === currentRecord?.Condition)?.Description || "";
    return prevRecord?.Condition === currentRecord?.Condition ? "Not Changed" : `${prev} ---> ${current}`;
  };

  // Function to get formatted value change
  const getFormattedValueChange = (source: string) => (record: any) => {
    const prevRecord = JSON.parse(record.oldValues);
    const currentRecord = JSON.parse(record.newValues);
    return prevRecord?.[source] === currentRecord?.[source]
      ? "Not Changed"
      : `${prevRecord?.[source] ?? ""} ---> ${currentRecord?.[source] ?? ""}`;
  };

  const ExportToExcel = (records, fetchRelatedRecords) => {
    fetchRelatedRecords(records, "createdBy", SourceVwUser).then(createdBy => {
      const data = records.map(record => ({
        ...record,
        createdBy: /^\d+$/.test(record?.createdBy)
          ? `${createdBy[record.createdBy]?.registerId} - ${createdBy[record.createdBy]?.name}`
          : record?.createdBy,
      }));
      ExcelExport(
        UpdateHistoryExcelColumns,
        data.map(v => [
          getFormattedValueChange("Pn")(v),
          getFormattedValueChange("Sn")(v),
          getFormattedValueChange("PnDesc")(v),
          getFormattedStorageChange(v),
          getFormattedConditionsChange(v),
          getFormattedValueChange("Note")(v),
          getFormattedValueChange("RequestId")(v),
          v.createdDate,
          v.createdBy,
        ]),
        UpdateHistoryExcelName
      );
    });
  };
  return (
    <>
      <Grid style={{ overflow: "auto" }}>
        <List
          {...props}
          resource="EntityHistorys"
          title=" "
          sort={{ field: "createdDate", order: "DESC" }}
          filterDefaultValues={{ entityId__eq: props?.id ?? 0, entityName__eq: "AarStorage" }}
          perPage={25}
          bulkActionButtons={false}
          hasCreate={false}
          exporter={ExportToExcel}
        >
          <Datagrid {...props} optimized>
            <FunctionField label="Pn" render={getFormattedValueChange("Pn")} />
            <FunctionField label="Sn" render={getFormattedValueChange("Sn")} />
            <FunctionField label="Pn Desc" render={getFormattedValueChange("PnDesc")} />
            <FunctionField label="Storage" render={getFormattedStorageChange} />
            <FunctionField label="Condition" render={getFormattedConditionsChange} />
            <FunctionField label="Note" render={getFormattedValueChange("Note")} />

            <FunctionField label="Ref Number" render={record => <RefNumberField record={record} />} />
            <CustomDateField source="createdDate" label="CREATED DATE" />
            <CreatedByField label="CREATED BY" link={false} />
          </Datagrid>
        </List>
      </Grid>
    </>
  );
};

export default AarStorageUpdateHistory;
